import React, { memo } from 'react';
import { SparklesIcon, Leaf, DollarSign, MapPinIcon } from 'lucide-react';
const ValueCards = () => {
  return <section className="py-20 bg-white" data-id="element-790">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-791">
        <div className="text-center mb-16" data-id="element-792">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-793">
            Why offices choose SmartSoda
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-794">
            The first all-in-one beverage dispenser that is transforming the
            workplace experience – choose from flavored waters, craft sodas,
            teas, lemonade, sports drinks and cold brew.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-795">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-796">
            <div className="mb-6 bg-blue-50 p-4 rounded-full" data-id="element-797">
              <SparklesIcon className="h-8 w-8 text-blue-600" data-id="element-798" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-799">
              Exceptional Taste
            </h3>
            <p className="text-gray-600 text-center" data-id="element-800">
              Crafted with alkaline water and vitamin-infused, clean-label
              flavors for a superior taste experience that delights employees
              and impresses clients.
            </p>
          </div>
          {/* Card 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-801">
            <div className="mb-6 bg-green-50 p-4 rounded-full" data-id="element-802">
              <Leaf className="h-8 w-8 text-green-600" data-id="element-803" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-804">
              Sustainable Solution
            </h3>
            <p className="text-gray-600 text-center" data-id="element-805">
              Drastically reduce plastic waste and carbon footprint while
              supporting your company's environmental goals with our
              eco-friendly system.
            </p>
          </div>
          {/* Card 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-806">
            <div className="mb-6 bg-amber-50 p-4 rounded-full" data-id="element-807">
              <DollarSign className="h-8 w-8 text-amber-600" data-id="element-808" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-809">
              Affordable & Transparent
            </h3>
            <p className="text-gray-600 text-center" data-id="element-810">
              Cut beverage costs by over 50% on average with our clear, upfront
              pricing.
            </p>
          </div>
          {/* Card 4 - New */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-811">
            <div className="mb-6 bg-purple-50 p-4 rounded-full" data-id="element-812">
              <MapPinIcon className="h-8 w-8 text-purple-600" data-id="element-813" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-814">
              Nationwide Service Network
            </h3>
            <p className="text-gray-600 text-center" data-id="element-815">
              Our professional partners ensure you receive excellent
              installation and service every step of the way.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-816">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-817">
            Book Your Free Demo Today
          </a>
        </div>
      </div>
    </section>;
};
export default ValueCards;